import AppBlock from "../../block/AppBlock";

const AppBanner = () => {
  return (
    <section
      className="section-bg layout-pb-md md:pt-40 md:pb-40 "
      data-aos="fade-up"
      style={{
        background:
          "linear-gradient(263.47deg, rgba(109, 200, 191, 0.13) 9.94%, rgba(255, 255, 255, 0.13) 91.64%)",
      }}
    >
      <div className="container rsl__Wrapper">
        <div className="appBanner-rsl row y-gap-30 items-center justify-between">
          <div className="col-lg-6 appBanner-content">
            <AppBlock />
          </div>
          {/* End .col */}

          <div className="col-lg-6">
            <img src="/img/app/1.png" alt="image" />
          </div>
          {/* End .col */}
        </div>
        {/* End .row */}
      </div>
      {/* End .container */}
    </section>
  );
};

export default AppBanner;
